import { trimValues } from 'lib/helpers/forms'

const permissionValueForPrimary = ({ parent, form, field }) => {
  // implicit or explicit yes
  if (
    parent?.primaryAccountHolder || // implicit yes
    ['true', true].includes(form[field]) // explicit yes
  ) {
    return true
  }

  // explicit no
  if (['false', false].includes(form[field])) {
    return false
  }

  // no selection
  return null
}

const permissionValue = ({ parent, form, field }) => {
  // implicit or explicit yes
  if (
    ['true', true].includes(form[field]) // explicit yes
  ) {
    return true
  } else {
    return false
  }
}

const toBooleanOrNull = (value) => {
  if (
    ['true', true].includes(value) // explicit yes
  ) {
    return true
  } else if (
    ['false', false].includes(value) // explicit no
  ) {
    return false
  } else {
    return null // implicit no choice made
  }
}

/**
 * Given an (optional) parent record and a Redux form state,
 * returns input fields for "createParent" and "updateParent" mutations
 **/
const parentMutationInput = ({ parent, form }) => {
  const trimmed = trimValues(form)

  return {
    firstName: trimmed.firstName,
    lastName: trimmed.lastName,
    relationshipToCampers: trimmed.relationshipToCampers,
    legalGuardian: toBooleanOrNull(trimmed.legalGuardian),
    primaryPhone: trimmed.primaryPhone,
    alternatePhone: trimmed.alternatePhone,
    streetAddress: trimmed.streetAddress,
    city: trimmed.city,
    region: trimmed.region,
    country: trimmed.country,
    postalCode: trimmed.postalCode,
    email: trimmed.email,
    employerName: trimmed.employerName,
    accountAccess: permissionValueForPrimary({
      parent,
      form: trimmed,
      field: 'accountAccess'
    }),
    pickup: permissionValueForPrimary({
      parent,
      form: trimmed,
      field: 'pickup'
    }),
    primaryPhoneType: trimmed.primaryPhoneType,
    smsOptIn: permissionValue({ parent, form: trimmed, field: 'smsOptIn' }),
    smsOptedAt: trimmed.smsOptedAt
  }
}

export { parentMutationInput, toBooleanOrNull }
